import { render, staticRenderFns } from "./ImportTutorialDialog.vue?vue&type=template&id=38c89e72&scoped=true"
import script from "./ImportTutorialDialog.vue?vue&type=script&lang=ts"
export * from "./ImportTutorialDialog.vue?vue&type=script&lang=ts"
import style0 from "./ImportTutorialDialog.vue?vue&type=style&index=0&id=38c89e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c89e72",
  null
  
)

export default component.exports